import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from "react-intl";
import {
  Button,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import { Calendar } from "@fullcalendar/core";
import interaction from "@fullcalendar/interaction";
import timeGridPlugin from '@fullcalendar/timegrid';
import moment from 'moment';
import momentTimezone from 'moment-timezone';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import {
  getAppointmentsByDate,
} from '../../../api/appointments/appointments';
import {
  APPOINTMENT_KEY_SLOTS,
  APPOINTMENT_TYPES
} from '../../../config/constants/Appointments/appointments_constants';
import { ENGLISH_LOCALE } from '../../../languages';
import { Messages } from '../../layout/Messages/Messages';
import { DatePickerWithIcon } from '../../shared/DatePickerWithIcon';
import { NOTIFICATION_CERTIFICATE_APPOINTMENT } from '../../../config/notifications';
import { UserDetails } from './modals/UserDetails';
import { PAGE_CONTEXTS, romaniaUTCOffset } from '../../../config/constants';
import { getAppointmentHolidays } from '../../../api/appointmentHolidays/appointmentHolidays';

let calendar;

function AppointmentsCalendarComponent(props) {
  const [ datePickerCurrentDate, setDatePickerCurrentDate ] = useState( moment().toDate() );
  const [ showModal, setShowModal ] = useState( false );
  const [ calendarViewType, setCalendarViewType ] = useState( 'timeGridDay' );
  const [ user, setUser ] = useState( null );
  const [ event, setEvent ] = useState( null );
  const [ currentDate, setCurrentDate ] = useState( null );
  const [ windowWidth, setWindowWidth ] = useState( window.innerWidth );
  const [ touchStart, setTouchStart ] = useState( 0 );
  const [ touchEnd, setTouchEnd ] = useState( 0 );
  const calendarRef = useRef( null );

  // eslint-disable-next-line

  useEffect( () => {
    const eventInterval = setInterval( () => {
      // Get appointments on each 15 minutes if user remains on the page, to disable slots
      calendar.refetchEvents();
    }, 900000 );

    window.addEventListener( 'resize', resizeHandler );

    createCalendar();

    return ( () => {
      calendar = null;
      clearInterval( eventInterval );
      window.removeEventListener( 'resize', resizeHandler );
    } );

    // eslint-disable-next-line
  }, [] );

  const generateEmptyEvents = (day) => {
    momentTimezone.tz.setDefault( 'Europe/Bucharest' );
    const startHour = 9;
    const startMinute = 30;

    day.set( { hour: startHour, minute: startMinute } );

    let slot = {};

    for(let i=0; i < 26; i++) {
      let isInFuture = moment().diff( day ) < 0;
      slot[day.unix()] = {
        0: isInFuture ? APPOINTMENT_KEY_SLOTS.ACTIVE.key : APPOINTMENT_KEY_SLOTS.INACTIVE.key,
        1: isInFuture ? APPOINTMENT_KEY_SLOTS.ACTIVE.key : APPOINTMENT_KEY_SLOTS.INACTIVE.key,
      }

      if (slot[day.unix()][0] === APPOINTMENT_KEY_SLOTS.ACTIVE.key) {
        slot[day.unix()][1] = APPOINTMENT_KEY_SLOTS.INACTIVE.key;
      }

      day.add( 15, 'minutes' );
    }

    return slot;
  }

  const resizeHandler = (event) => {
    setWindowWidth( event.target.innerWidth );
  }

  const generateEvent = (slots, key, column, index) => {
    let event = {
      id: key + column,
      key: slots[key][index],
      title: slots[key][index] !== APPOINTMENT_KEY_SLOTS.ACTIVE.key && slots[key][index] !== APPOINTMENT_KEY_SLOTS.INACTIVE.key ? slots[key][index] : '',
      start: moment.unix( key ).toDate(),
      end: moment.unix( key ).add( 15, 'minute' ).toDate(),
      allDay: false,
      user: slots[key][column],
      className: slots[key][index] !== APPOINTMENT_KEY_SLOTS.ACTIVE.key && slots[key][index] !== APPOINTMENT_KEY_SLOTS.INACTIVE.key ? 'event-reserved' : 'event-available',
    }

    // Check if event is in past
    if (moment().diff( event.start ) > 0) {
      event.className = 'event-no-action';
    }

    return event;
  }

  const getContentHeight = () => {
    if (windowWidth > 1000) {
      return 1500;
    }

    if (windowWidth > 768 && windowWidth <= 1000) {
      return 1300;
    }

    if (windowWidth > 300 && windowWidth <= 768) {
      return 1200;
    }
  }

  const getDayHeaderFormat = () => {
    if (windowWidth > 500) {
      return { weekday: 'long', month: 'short', day: 'numeric' }
    } else {
      return { weekday: 'short', month: 'short', day: 'numeric' }
    }
  }

  const getTitleFormat = () => {
    if (windowWidth > 500) {
      return { year: 'numeric', month: 'long', day: '2-digit' }
    } else {
      return { year: 'numeric', month: 'short', day: '2-digit' }
    }
  }

  const createCalendar = () => {
    calendar = new Calendar( calendarRef.current, {
      plugins: [ interaction, momentTimezonePlugin, timeGridPlugin ],
      hiddenDays: [ 0, 6 ],
      dayHeaderFormat: getDayHeaderFormat(),
      contentHeight: getContentHeight(),
      eventOrder: 'id',
      initialView: "timeGridDay",
      titleFormat: getTitleFormat(),
      initialDate: moment().toDate(),
      slotDuration: "00:15:00",
      slotMinTime: "09:30",
      slotMaxTime: "16:00",
      timeZone: 'Europe/Bucharest',
      slotEventOverlap: false,
      allDaySlot: false,
      expandRows: true,
      nowIndicator: false,
      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
        omitZeroMinute: false,
        meridiem: 'short'
      },
      slotLabelInterval: { minute: 15 },
      eventMinHeight: 15,
      selectable: false,
      editable: false,
      events: function (info, successCallback) {
        getAppointmentHolidays( {
          pagination: {
            intervalFrom: moment( info.start ).unix(),
            intervalTo: moment( info.end ).unix(),
            sort: 'ASC',
          },
          notificationId: NOTIFICATION_CERTIFICATE_APPOINTMENT
        } ).then( response => {

          if (response.status === 200) {
            let holidayEvents = response.data.data;

            getAppointmentsByDate( {
              urlParams: {
                start: moment( info.start ).unix(),
                end: moment( info.end ).unix(),
                type: APPOINTMENT_TYPES.GENERATE_CERTIFICATE,
                page_context: PAGE_CONTEXTS.APPOINTMENTS.LIST,
              },
              notificationIstartDayOfWeekd: NOTIFICATION_CERTIFICATE_APPOINTMENT
            } ).then( response => {
              if (response.status === 200) {
                let reservedEvents = response.data.data;
                let slots = {};
                let startDayOfWeek = momentTimezone.tz( info.start, 'Europe/Bucharest' );
              
                for (let i = 0; i < 5; i++) {
                  const generatedSlots = generateEmptyEvents( moment( startDayOfWeek ) );
                  slots = { ...slots, ...generatedSlots };
                  startDayOfWeek.add( 1, 'days' );
                }

                Object.entries(slots).forEach( slot => {
                  let slotDate = moment.unix(slot[0]);

                  for (const holidayEvent of holidayEvents) {
                    let holidayEventDateStartFrom = moment.unix(holidayEvent.day_as_timestamp);
                    let holidayEventDateStartAt = moment.unix(holidayEvent.day_as_timestamp).endOf('day');

                    if (slotDate.isBetween(holidayEventDateStartFrom, holidayEventDateStartAt)) {
                      slots[slot[0]][1] = props.intl.formatMessage({ id: "components.pages.appointments.appointmentsCalendar.holiday" });
                      slots[slot[0]].b = props.intl.formatMessage({ id: "components.pages.appointments.appointmentsCalendar.holiday" });
                  
                      slots[slot[0]][0] = props.intl.formatMessage({ id: "components.pages.appointments.appointmentsCalendar.holiday" });
                      slots[slot[0]].a = props.intl.formatMessage({ id: "components.pages.appointments.appointmentsCalendar.holiday" });
                    }
                  }

                } );

                if (reservedEvents.length) {
                  // Set on appointments all reserved events
                  reservedEvents.forEach( reservedEvent => {
                    if (slots[reservedEvent.start][1] === APPOINTMENT_KEY_SLOTS.ACTIVE.key) {
                      slots[reservedEvent.start][1] = `${reservedEvent.user.first_name.charAt( 0 )}. ${reservedEvent.user.last_name}`;
                      slots[reservedEvent.start].b = `${reservedEvent.user.first_name} ${reservedEvent.user.last_name}`;
                    }
                  
                    if (slots[reservedEvent.start][0] === APPOINTMENT_KEY_SLOTS.ACTIVE.key) {
                      slots[reservedEvent.start][0] = `${reservedEvent.user.first_name.charAt( 0 )}. ${reservedEvent.user.last_name}`;
                      slots[reservedEvent.start].a = `${reservedEvent.user.first_name} ${reservedEvent.user.last_name}`;
                      slots[reservedEvent.start][1] = APPOINTMENT_KEY_SLOTS.ACTIVE.key;
                    }
                  } );
                }

                let events = [];

                Object.keys( slots ).forEach( key => {
                  let event1 = generateEvent( slots, key, 'a', 0 );
              
                  if (event1.key === APPOINTMENT_KEY_SLOTS.RESERVED.key) {
                    event1.reserved = true;
                  }
                
                  let event2 = generateEvent( slots, key, 'b', 1 );
                
                  events.push( event1, event2 );
                } );
              
                successCallback( events );
              
                return;
              }
            } );
          }
        } );
      },
      firstDay: props.locale.lang === ENGLISH_LOCALE.lang ? 0 : 1, // 0 = Sunday, 1 = Monday
      eventTimeFormat: {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        meridiem: false,
        hour12: false
      },
      displayEventEnd: false,
      eventDisplay: 'block',
      headerToolbar: "",
      eventDidMount: (info) => {
        let eventTitle = info.el.children[0].children[0].children[1].children[0].innerHTML;
        if (eventTitle && eventTitle !== '&nbsp') {
          let span = document.createElement( "span" );
          span.classList.add( 'event-title-block' );
          span.innerHTML = eventTitle;
          info.el.children[0].children[0].children[1].children[0].innerHTML = "";
          info.el.children[0].children[0].children[1].children[0].appendChild( span );
        }
      },
      eventClick: ({ event }) => {
        let holidayKey = props.intl.formatMessage({ id: "components.pages.appointments.appointmentsCalendar.holiday" });
        
        if (event.extendedProps.user && event.extendedProps.key !== holidayKey) {
          setUser( event.extendedProps.user );
          setEvent( event );
          setShowModal( true );
        }
      },
    } );

    calendar.setOption( 'locale', props.locale.lang );
    calendar.render();
    setCurrentDate( calendar.view.title );

    formatCalendarTitle();

  };

  const handleTouchStart = (e) => {
    if (windowWidth < 500) {
      setTouchStart( e.targetTouches[0].clientX )
    }
  }

  function handleTouchMove(e) {
    if (windowWidth < 500) {
      setTouchEnd( e.targetTouches[0].clientX );
    }
  }

  function handleTouchEnd() {
    if (windowWidth < 500) {
      if (touchStart - touchEnd > 150 && touchEnd !== 0) {
        setTouchEnd(0);
        nextCalendarPage();
      }

      if (touchStart - touchEnd < -150 && touchEnd !== 0) {
        setTouchEnd(0);
        prevCalendarPage();
      }
    }
  }

  const nextCalendarPage = () => {
    calendar.next();
    setDatePickerCurrentDate( calendar.getDate() );
    setCurrentDate( calendar.view.title );
  }

  const prevCalendarPage = () => {
    calendar.prev();
    setCurrentDate( calendar.view.title );
    setDatePickerCurrentDate( calendar.getDate() );
  }

  const formatCalendarTitle = () => {
    let activeStart = calendar.view.activeStart;
    let activeEnd = calendar.view.activeEnd;
    let formattedDate;
    if (moment( activeStart ).get( 'month' ) !== moment( activeEnd ).get( 'month' )) {
      formattedDate = `${moment( activeStart ).format( 'DD MMM' )} - ${moment( activeEnd ).format( 'DD MMM yyyy' )}`;

      let calendarTitle = document.querySelector( '.fullcalendar-title' );

      if (calendarTitle) {
        setTimeout( () => {
          calendarTitle.innerHTML = formattedDate;
        } );
      }
    }
  }

  const changeView = (newView) => {
    setCalendarViewType( newView );
    calendar.changeView( newView, datePickerCurrentDate );
    setCurrentDate( calendar.view.title );
    calendar.refetchEvents();
  };

  return (
    <div className="appointment-container appointments-calendar">
      <div className="appointments-calendar-toolbar">
        <div className="appointments-calendar-navigation calendar-date-title">
          <Button
            className="fullcalendar-btn-prev btn-neutral"
            color="default"
            onClick={() => {
              prevCalendarPage();
              formatCalendarTitle();
            }}
            size="sm"
          >
            <i className="fas fa-angle-left"/>
          </Button>
          <h2 className="fullcalendar-title mb-0">
            {currentDate}
          </h2>
          <Button
            className="fullcalendar-btn-next btn-neutral"
            color="default"
            onClick={() => {
              nextCalendarPage();
              formatCalendarTitle();
            }}
            size="sm"
          >
            <i className="fas fa-angle-right"/>
          </Button>
        </div>
        <div className="appointments-calendar-controls">
          {windowWidth > 768 && <>
            <Button
              className="btn-neutral"
              color="default"
              data-calendar-view="basicWeek"
              onClick={() => changeView( "timeGridWeek" )}
              size="sm"
            >
              Week
            </Button>
            <Button
              className="btn-neutral"
              color="default"
              data-calendar-view="basicDay"
              onClick={() => changeView( "timeGridDay" )}
              size="sm"
            >
              Day
            </Button>
          </>}
          <DatePickerWithIcon
            name="appointment-date"
            className="form-control"
            placeHolderTextId="pages.appointments.selectDate"
            selectedDate={datePickerCurrentDate}
            minDate={moment().toDate()}
            dateFormat="dd MMM. yyyy"
            disableWeekendDay={true}
            yearDropdownItemNumber={50}
            onChange={(date) => {
              setDatePickerCurrentDate( date );
              calendar.changeView( calendarViewType, date );
              setCurrentDate( calendar.view.title );
              formatCalendarTitle();
            }}
          />
        </div>
      </div>
      <div className="appointments-calendar-timezone">
        <FormattedMessage id="pages.appointment.utc_displayed_hours"/>{romaniaUTCOffset}
      </div>
      <div className="appointments-calendar-notification">
        <Messages notificationId={NOTIFICATION_CERTIFICATE_APPOINTMENT}/>
      </div>
      <div className="appointments-calendar-scroll">
        <div className="card-calendar appointments-calendar-canvas">
          <div
            className="calendar"
            data-toggle="calendar"
            id="calendar"
            ref={calendarRef}
            onTouchStart={touchStartEvent => handleTouchStart( touchStartEvent )}
            onTouchMove={touchMoveEvent => handleTouchMove( touchMoveEvent )}
            onTouchEnd={() => handleTouchEnd()}
          />
        </div>
      </div>
      {showModal && <UserDetails
        user={user}
        event={event}
        closeModal={() => {
          setUser( null );
          setEvent( null );
          setShowModal( false );
        }}
        showModal={showModal}/>}
    </div>
  );
}

AppointmentsCalendarComponent.defaultProps = {};

const mapStateToProps = state => ( {
  locale: state.locale,
} );

const AppointmentsCalendar = injectIntl( connect( mapStateToProps, null )( AppointmentsCalendarComponent ) );

export { AppointmentsCalendar, AppointmentsCalendarComponent };
